import React from 'react';

import Header from '../../components/Header';

import './styles.scss';

const Page = (props) => {
  
  const buscar = (value) => {
    if (value) {
      props.search(value);
    }
  }
  
  return (
    <div className='row'>
      <div className='w-100'>
        { props.children }
      </div>
    </div>
  )
}

export default Page;